<div class="common-wrapper">
    <div class="main-hd-txt">
        <span>
            <h4>FACILITY MANAGER<span class="head-btn-style">
                <button *ngIf="!listView" (click)="goToBackTab()" class="go-back-btn-head" title="Back Tab">
                    <i class="bi bi-arrow-left-circle"></i> Back</button></span><span class="head-btn-style">
                    <button *ngIf="!listView" (click)="save($event)" class="save-btn-head" [disabled]="saveDisabled" title="Save">
                    <i class="bi bi-file-earmark-plus"></i> Save</button></span></h4>
        </span>
    </div>
    <div *ngIf="listView" class="top-btns">
        <grid [entities]="facilitymanagers" [actionExclude]="['feedback','column']" [checkboxCol]="true"
            [entityColumns]="facilitymanagerColumns" [selectionField]="'FacilityManager_Id'" [addEntityIcon]="'bi bi-plus-square'"
            [addEntityCaption]="'Add'" [downloadEntityCaption]="'Download'" (downloadEntities)="onExcelExport()"
            (addEntity)="addFacilityManager($event)" (editEntity)="editFacilityManager($event)"
            (refreshEntities)="refreshFacilityManager($event)" (deleteEntity)="deleteFacilityManager($event)"
            (onPaginationChange)="onPaginationChange($event)" [serverPagination]="true" [pageSizes]="pageSizes"
            [pageSize]="defaultPageSize" [skip]="pageSkip" (onFilterChange)="onFilterChange($event)"></grid>

    </div>

    <div *ngIf="!listView">  
        <div class="row sub-head"> 
            <div class="col-md-7 text-bold">
                {{ formCaption }}
            </div>
            <div class="col-md-5 text-end">
                <button (click)="clearFacilityManager()" class="btn-3 bt-3-ic"><span>Clear</span></button>
                <button (click)="revertChanges()" class="btn-3 bt-4-ic"><span>Revert Changes</span></button>
                <button (click)="gotoBack()" class="btn-3 bt-4-ic"><span>Go Back</span></button>
            </div> 
        </div>
        
        <div class="col-md-12 content-area">
            <div class="row">
                <div class="col-md-4 mb-2"> 
                        <dropdown [caption]="'Facility Manager Name'" [formData]="entity" [data]="employees" [class] = "'form-control'"
                        [mandatory]="true" [filterable]="true" (filterChanged)="getAllEmployees($event)" id="drp_Department_Head"
                        [(ngModel)]="entity.Emp_Ref_Id" [textField]="'EmployeeName'" [valueField]="'Emp_Ref_Id'"
                        [fieldName]="'Emp_Ref_Id'" [selectedItem]="selectedEmployee"   (selectionChanged)="Employeechanged($event)"  ngDefaultControl>
                    </dropdown>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Email id'" [mandatory]="true" [maxlength]="100" [formData]="entity"
                        [maxlength]="25" [disabled] ="true" [fieldName]="'EmailId'" [(ngModel)]="entity.EmailId" ngDefaultControl>
                    </textbox>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Phone'" [mandatory]="false" [maxlength]="10" [formData]="entity"
                        [fieldName]="'Phone'" [disabled] ="true" (keypress)="numberOnly($event)" [(ngModel)]="entity.Phone"
                        ngDefaultControl></textbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-4 mb-2">
                    <dropdown [caption]="'Department'" [formData]="entity" [data]="departments" [mandatory]="false"
                        [filterable]="true" (filterChanged)="getAllDepartments($event)" [class]="'form-control'"
                        [(ngModel)]="entity.Department_Id" [textField]="'DepartmentName'" [valueField]="'Department_Id'"
                        [disabled] ="true"  [fieldName]="'Department_Id'" [selectedItem]="selectedDepartment" ngDefaultControl>
                    </dropdown>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-2">
                    <textbox [caption]="'Address'" [mandatory]="true" [multiline]="true" [formData]="entity"
                        [maxlength]="500" [fieldName]="'FacilityManagerAddress'" [(ngModel)]="entity.FacilityManagerAddress"
                        ngDefaultControl>
                    </textbox>
                </div>
            </div> -->
            <div class="row">
                <div class="col-md-4">
                    <checkbox [caption]="' Active'" [(ngModel)]="entity.IsActive"></checkbox>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-1">
                    <btn [label]="'Back'" (click)="goToBackTab()" [class]="'btn-next btn-11'"
                        [type]="'button'" title="Back Tab"></btn>
                </div>
                <div class="col-md-4 mb-2">
                    <btn [label]="'Save'" (click)="save($event)" [class]="'btn-1 btn-11'" [disabled]="saveDisabled"
                        [type]="'button'"></btn>
                </div>
            </div> -->
        </div>
        
    </div>
</div>
<ng-template #view let-dataItem let-rowIndex="rowIndex">
    <i class="bi bi-eye-fill" (click)="open(dataItem)"></i>
  </ng-template>
  <kendo-dialog title="Facility Manager Details" *ngIf="opened" (close)="close()" [height]="500" [width]="1000">
    <div class="col-md-12 content-area">
        <div class="row">
        <div class="col-md-4 br-table-data">
            <label for="FacilityManagerName" class="label label-1">Facility Manager Name : </label> {{details.FacilityManagerName }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="EmailId" class="label label-1">EmailId : </label> {{details.EmailId }}
          </div>
          <div class="col-md-4 br-table-data">
            <label for="Phone" class="label label-1">Phone Number : </label> {{details.Phone }}
          </div>
        </div>
        </div>
    </kendo-dialog>
<kendo-excelexport [data]="facilitymanagers.data" [collapsible]="true" fileName="FacilityManager.xlsx" #excelexport>
    <kendo-excelexport-column field="SlNo" title="Sl.No." [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="FacilityManagerName" title="Facility Manager" [width]="200">
    </kendo-excelexport-column>
    <!-- <kendo-excelexport-column field="FacilityManagerAddress" title="Address" [width]="200">
    </kendo-excelexport-column> -->
    <kendo-excelexport-column field="EmailId" title="Email" [width]="200">
    </kendo-excelexport-column>
    <kendo-excelexport-column field="Phone" title="Phone" [width]="200">
    </kendo-excelexport-column>
</kendo-excelexport>